const arr = [
    // acity详情页(app使用)
    {
        path: '/order/cancel',
        component: () => import(/* webpackChunkName:"order-cancel"*/'@/pages/order/cancel/index.vue'),
        name: 'order/cancel',
        meta: {
            title: '取消订单',
        },
    },
    // 支付成功页
    {
        path: '/pay/success',
        component: () => import(/* webpackChunkName:"order-cancel"*/'@/pages/order/success/index.vue'),
        name: 'pay/success',
        meta: {
            title: '支付状态',
        },
    },
];
export default arr;
